import { createFileRoute } from "@tanstack/react-router";
import { CrudManager } from "@/components/admin/CrudManager";

export const Route = createFileRoute("/admin/numeros")({ component: Page });

function Page() {
  return (
    <CrudManager
      table="numbers"
      label="Números"
      fields={[
        { name: "value", label: "Valor", type: "text", required: true },
        { name: "suffix", label: "Sufixo", type: "text", placeholder: "+, %, mil..." },
        { name: "label", label: "Rótulo", type: "text", required: true },
        { name: "icon", label: "Ícone (nome lucide)", type: "text" },
        { name: "sort_order", label: "Ordem", type: "number" },
        {
          name: "status",
          label: "Status",
          type: "select",
          options: [
            { label: "Rascunho", value: "draft" },
            { label: "Publicado", value: "published" },
            { label: "Oculto", value: "hidden" },
          ],
        },
      ]}
      columns={[
        { key: "value", label: "Valor" },
        { key: "label", label: "Rótulo" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
